import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const listSchema: CollectionCreateSchema = {
  name: CollectionName.List,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "list_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "list_description",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "list_category",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "table_name",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "field_unique_id",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "user_configurable",
      type: "bool",
      sort: true,
    },
    {
      name: "created_at",
      type: "int64",
      sort: true,
    },
    {
      name: "created_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
